import { Controller } from "@hotwired/stimulus"
import {translate as t} from 'common/i18n'
import Dialog from 'common/dashboard/dashboard/dialog'
import toastr from 'toastr';
toastr.options = {"closeButton": true, "progressBar": true, "timeOut": "10000" }

export default class extends Controller {
  static targets = ['fipsasConnect', 'fipsasCreate', 'merge']
  static values = {
    searchPeopleUrl: String,
    searchFipsasPeopleUrl: String,
    fipsasTeamsUrl: String,
    teamsUrl: String,
    team: Object,
    person: Object,
  }

  fipsasCreate() {
    this.createApiCreateDialog()
  }

  fipsasConnect() {
    this.createApiConnectDialog()
  }

  merge() {
    this.createMergeDialog()
  }

  async doConnect({detail: {person}}) {
    let question = t('admin.people.fipsas_connect.question', {
      name_a: this.personValue.name,
      last_name_a: this.personValue.last_name,
      team_name_a: this.personValue.teams?.map((t) => t.name)?.join(', ') || '-',
      fipsas_number_a: this.personValue.fipsas_number || '-',
      name_b: person.name,
      last_name_b: person.last_name,
      team_name_b: person.teams?.map((t) => t.name)?.join(', ') || '-',
      fipsas_number_b: person.badge_code || '-',
    });

    if(await Dialog.confirm({title: t('admin.people.fipsas_connect.title'), message: question})) {
      let ctrl = this.application.getControllerForElementAndIdentifier(this.__dialog, 'people--search')
      ctrl.beginLoad()

      let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

      const req = new Request(this.fipsasConnectTarget.href)
      const params = {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({person_badge_code: person.athlete_badges?.map((b)=> b.code)})
      }

      let response = await fetch(req, params)
      let data = await response.json()

      ctrl.endLoad()
      if(response.status > 300) {
        toastr.error(data.error)
      } else {
        if(data.message) toastr.success(data.message)
        if(data.warning) toastr.warning(data.warning)
        ctrl.close()
        this.dispatch("reload", {prefix: false})
      }
    }
  }

  async doMerge({detail: {person}}) {
    let question = t('admin.people.merge.question', {
      name_a: this.personValue.name,
      last_name_a: this.personValue.last_name,
      team_name_a: this.personValue.teams?.map((t) => t.name)?.join(', ') || '-',
      fipsas_number_a: this.personValue.badge_code || this.personValue.fipsas_number || '-',
      name_b: person.name,
      last_name_b: person.last_name,
      team_name_b: person.teams?.map((t) => t.name)?.join(', ') || '-',
      fipsas_number_b: person.badge_code || '-',
    });

    if(await Dialog.confirm({title: t('admin.people.merge.title'), message: question})) {
      let ctrl = this.application.getControllerForElementAndIdentifier(this.__dialog, 'people--search')
      ctrl.beginLoad()

      let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const req = new Request(this.mergeTarget.href)
      const params = {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({merge_with: person.id})
      }

      let response = await fetch(req, params)
      let data = await response.json()

      ctrl.endLoad()
      if(response.status > 300) {
        toastr.error(data.error)
      } else {
        toastr.success(data.message)
        ctrl.close()
        this.dispatch("reload", {prefix: false})
      }
    }
  }

  createApiCreateDialog() {
    let dialog = this.createDialog()

    dialog.dataset['people-ImportSearchUrlValue'] = this.searchFipsasPeopleUrlValue
    dialog.dataset['people-ImportTeamsUrlValue']  = this.teamsUrlValue
    dialog.dataset['people-ImportActionUrlValue'] = this.fipsasCreateTarget.href
    if(this.hasTeamValue)
      dialog.dataset['people-ImportTeamValue'] = JSON.stringify(this.teamValue)
    dialog.dataset.controller = 'people--import'
  }

  createApiConnectDialog() {
    let dialog = this.createDialog()

    dialog.dataset['people-SearchSearchUrlValue'] = this.searchFipsasPeopleUrlValue
    dialog.dataset['people-SearchTeamsUrlValue']  = this.teamsUrlValue
    dialog.dataset['people-SearchNameValue']  = this.personValue.name
    dialog.dataset['people-SearchLastNameValue']  = this.personValue.last_name
    dialog.dataset['people-SearchBadgeCodeValue']  = this.personValue.fipsas_number || ''
    dialog.dataset['people-SearchScopeValue']  = 'not_connected,team_connected'
    dialog.dataset['people-SearchTitleValue']  = t('admin.people.fipsas_connect.title')
    dialog.dataset['people-SearchBodyTextValue']  = t('admin.people.fipsas_connect.help', {
      name: this.personValue.name,
      last_name: this.personValue.last_name,
      team_name: this.personValue.team?.name,
      fipsas_number: this.personValue.fipsas_number || '-',
    })
    dialog.dataset['people-SearchSelectButtonValue']  = `<i class="fas fa-link"></i> ${t('admin.people.fipsas_connect.connect')}`
    if(this.hasTeamValue)
      dialog.dataset['people-SearchTeamValue'] = JSON.stringify(this.teamValue)
    dialog.classList.add('text-left')
    dialog.dataset.action = 'people--search:select->people--actions#doConnect'
    dialog.dataset.controller = 'people--search'
  }

  createMergeDialog() {
    let dialog = this.createDialog()

    dialog.dataset['people-SearchSearchUrlValue'] = this.searchPeopleUrlValue
    dialog.dataset['people-SearchTeamsUrlValue']  = this.teamsUrlValue
    dialog.dataset['people-SearchNameValue']  = this.personValue.name
    dialog.dataset['people-SearchLastNameValue']  = this.personValue.last_name
    dialog.dataset['people-SearchExcludeIdsValue']  = this.personValue.id
    dialog.dataset['people-SearchTitleValue']  = t('admin.people.merge.title')
    dialog.dataset['people-SearchBodyTextValue']  = t('admin.people.merge.help', {
      name: this.personValue.name,
      last_name: this.personValue.last_name,
      team_name: this.personValue.team?.name,
      fipsas_number: this.personValue.fipsas_number || '-',
    })
    dialog.dataset['people-SearchSelectButtonValue']  = `<i class="fas fa-link"></i> ${t('admin.people.merge.merge')}`
    if(this.hasTeamValue)
      dialog.dataset['people-SearchTeamValue'] = JSON.stringify(this.teamValue)
    dialog.classList.add('text-left')
    dialog.dataset.action = 'people--search:select->people--actions#doMerge'
    dialog.dataset.controller = 'people--search'
  }

  createDialog() {
    this.__dialog = document.getElementById('person-actions-dialog')
    if(this.__dialog) {
      this.__dialog.remove()
      this.__dialog = null;
    }
    if(!this.__dialog) {
      this.__dialog = document.createElement('div')
      this.__dialog.id = 'person-actions-dialog'
      this.element.appendChild(this.__dialog)
    }

    return this.__dialog
  }
}
